<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col clas="py-0">{{ accommodationLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex sm12>
            <v-text-field
              label="Name"
              v-model="a.name"
              @input="$v.a.name.$touch()"
              @blur="$v.a.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col>
            <v-switch v-model="a.notInUse" label="Not In Use"></v-switch>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-content>
</template>

<script>
import {
  ACCOMMODATION_SUPPLIER_TYPE_UPDATE_MUTATION,
  ACCOMMODATION_SUPPLIER_TYPE_CREATE_MUTATION,
} from "../../../../constants/graphql";
import { required } from "vuelidate/lib/validators";

export default {
  name: "AccommodationEditor",

  props: {
    accommodation: {
      type: Object,
      default: () => ({}),
    },

    doSaveAccommodation: {
      type: Boolean,
      default: false,
    },

    accommodationEditorDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      a: { ...this.accommodation },
      debug: false,
    };
  },

  methods: {
    saveAccommodation() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context == "edit"
            ? ACCOMMODATION_SUPPLIER_TYPE_UPDATE_MUTATION
            : ACCOMMODATION_SUPPLIER_TYPE_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.a,
            },
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    accommodationLabel() {
      return this.accommodation.id != null
        ? this.accommodation.name
        : "New Accommodation Supplier Type";
    },
    context() {
      return this.accommodation.id != null ? "edit" : "create";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.a.name.$dirty) {
        return errors;
      }
      if (!this.$v.a.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
  },

  watch: {
    accommodation(data) {
      let accommodation = { ...data };
      delete accommodation.__typename;
      this.a = accommodation;
    },
    accommodationEditorDialog(value) {
      if (!value) {
        this.t = {};
        this.$v.$reset();
      }
    },
    doSaveAccommodation(value) {
      if (value) {
        this.saveAccommodation();
      }
    },
  },
  validations: {
    a: {
      name: { required },
    },
  },
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/gt/admin/service-types/AccommodationEditor.vue